<template lang="pug">
section.main(:class="collapsed ? 'wide' : 'narrow'")
  Header(ref="header")
  Menu
  section.page.user(v-if="$auth.isAuthenticated && currentUser")
    b-navbar.title
      b-navbar-brand
        i.icon.fas.fa-address-card
        span {{ page.title }}
      b-navbar-nav.ml-auto
        b-nav-item
          b-button(variant="link",@click="onClose()") 一覧へ戻る

    section.body(ref="body")
      ValidationObserver(slim,ref="observer")
        b-form.form(ref="form",:data-mode="mode",@submit.prevent)
          b-container(fluid)
            b-row.pt-3
              b-col(cols=6)
                b-form-group(label="氏名",label-for="input-name",description="",required)
                  ValidationProvider(rules="required",name="氏名",v-slot="{ errors }")
                    b-form-input#input-name(ref="input-name",v-model="datum.name",type="text",required,placeholder="氏名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group.form_group-email(label="メールアドレス",label-for="input-email",description="",required)
                  ValidationProvider(rules="required|email",name="メールアドレス",v-slot="{ errors }")
                    b-form-input#input-email(v-model="datum.email",type="email",required,placeholder="メールアドレスを入力してください",@input="validateInput",disabled,readonly)
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col(cols=6)
                b-form-group(label="携帯電話番号",label-for="input-mobile",description="")
                  ValidationProvider(:rules="{ regex: /^0[0-9]{1,4}\-?[0-9]{1,4}\-?[0-9]{4}$/, min: 10, max: 20 }",name="携帯電話番号",v-slot="{ errors }")
                    b-form-input#input-mobile(v-model="datum.mobile",type="tel",placeholder="携帯電話番号を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
            b-row(v-if="datum && (datum.role === 'agent' || datum.role === 'consultant')")
              b-col(cols=6)
                b-form-group(label="会社名",label-for="input-company",description="")
                  ValidationProvider(rules="",name="会社名",v-slot="{ errors }")
                    b-form-input#input-company(v-model="datum.company",type="text",placeholder="会社名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
            b-row
              b-col(cols=6)
                b-form-group(label="部署",label-for="input-department",description="")
                  ValidationProvider(rules="",name="部署",v-slot="{ errors }")
                    b-form-input#input-department(v-model="datum.department",type="text",placeholder="部署を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group(label="役職",label-for="input-position",description="")
                  ValidationProvider(rules="",name="役職",v-slot="{ errors }")
                    b-form-input#input-position(v-model="datum.position",type="text",placeholder="役職を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col(cols=6)
                b-form-group(label="Slack ID",label-for="input-slackId",description="")
                  ValidationProvider(rules="",name="Slack ID",v-slot="{ errors }")
                    b-form-input#input-slackId(v-model="datum.slackId",type="text",placeholder="Slack ID を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group(label="チャットワークID",label-for="input-chatworkId",description="")
                  ValidationProvider(rules="",name="チャットワークID",v-slot="{ errors }")
                    b-form-input#input-chatworkId(v-model="datum.chatworkId",type="text",placeholder="チャットワークIDを入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row(v-if="currentUser && (currentUser.role === 'admin' || currentUser.role === 'master')")
              b-col(cols=6)
                b-form-group(label="権限ロール",label-for="input-role",description="",required)
                  ValidationProvider(rules="",name="権限ロール",v-slot="{ errors }")
                    //-input.d-none(type="text",required,v-model="datum.role")
                    b-form-select#input-role(v-model="datum.role",:options="options.role",required,placeholder="権限ロールを選択してください",@change="validateInput",:disabled="!editable || (currentUser.role === 'agent' || currentUser.role === 'consultant')",:readonly="!editable || (currentUser.role === 'agent' || currentUser.role === 'consultant')")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

      b-navbar.border-top.bottom-nav.bg-secondary
        b-navbar-nav
          b-nav-item
            b-button(variant="primary",v-show="mode === 'add' || mode === 'edit'",@click="onSave()",:disabled="!valid || !changed")
              span 保存
        b-navbar-nav.ml-auto
          b-nav-item
            b-button.mx-2(v-if="currentUser && currentUser.acl && currentUser.acl.users && currentUser.acl.users.patch",variant="outline-danger",@click="onDelete()",:disabled="!currentUser || !currentUser.acl || !currentUser.acl.users || !currentUser.acl.users.delete || !(currentUser.role === 'admin' || currentUser.role === 'master') || String(currentUser._id) === String(datum._id)")
              span 削除
</template>

<script>
import { isEqual } from 'lodash'

import { getData, postData, patchData, deleteData } from '../utils/api'

import { clone, difference, optionsRole } from '../utils/libs'

const page = {
  id: 'user',
  title: 'メンバー情報'
}

export default {
  // props: ['mode'],
  data () {
    return {
      mask: false,
      page: page,
      collapsed: true,
      currentUser: null,
      mode: null,
      editable: null,
      changed: false,
      valid: false,
      datum: {},
      recentDatum: {},
      options: {
        role: []
      }
    }
  },
  mounted () {
    this.mode = 'add'
    this.editable = true
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.mode = 'show'
      this.editable = false
    }

    // this.options.role = optionsRole()

    this.changeMode()
  },
  methods: {
    async validateInput () {
      await this.$refs.observer.reset()
      this.valid = await this.$refs.observer.validate()

      let currentDatum = clone(this.datum)

      const diffDatum = difference(currentDatum, this.recentDatum)
      if (!isEqual({}, diffDatum)) {
        this.changed = true
      }
      this.recentDatum = clone(this.datum)
    },
    changeMode () {
      if (this.mode === 'add' || this.mode === 'edit') {
        this.editable = true
      } else {
        this.editable = false
      }
      this.loadData()
    },
    async loadData () {
      this.mask = true

      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      this.options.role = optionsRole()
      /*
      let orgRoleOptions = clone(this.options.role)
      if (this.currentUser.role === 'admin') {
      } else if (this.currentUser.role === 'master' || this.currentUser.role === 'manager' || this.currentUser.role === 'recruiter' || this.currentUser.role === 'staff') {
        this.options.role = []
        for (let orgRole of orgRoleOptions) {
          if (orgRole.value === 'master' || orgRole.value === 'manager' || orgRole.value === 'recruiter' || orgRole.value === 'staff') {
            this.options.role.push(orgRole)
          }
        }
      } else if (this.currentUser.role === 'agent' || this.currentUser.role === 'consultant') {
        this.options.role = []
        for (let orgRole of orgRoleOptions) {
          if (orgRole.value === this.currentUser.role) {
            this.options.role.push(orgRole)
          }
        }
      }
      */

      let message = null

      this.datum = {}
      this.recentDatum = {}

      if (this.mode === 'add') {
        this.handleLink(`/${this.$route.params.directory}/users`)
        /*
        if (!this.currentUser.acl || !this.currentUser.acl.users || !this.currentUser.acl.users.post) {
          this.handleLink(`/${this.$route.params.directory}/users`)
        }

        this.datum = {}
        this.changed = false

        this.$nextTick(() => {
          this.$refs.observer.reset()
        })
        */
      } else if (this.$route.params.id) {
        if (!this.currentUser.acl || !this.currentUser.acl.users || !this.currentUser.acl.users.get) {
          this.handleLink(`/${this.$route.params.directory}/users`)
        }

        if (this.currentUser.acl && this.currentUser.acl.users && this.currentUser.acl.users.patch) {
          this.editable = true
          this.mode = 'edit'
        }

        await getData(`/users/${this.$route.params.id}`).then((datum) => {
          if (datum) {
            this.datum = clone(datum)

            if (this.datum.role === 'admin' && this.currentUser.role !== 'admin') {
              this.handleLink(`/${this.$route.params.directory}/users`)
            }

            let orgRoleOptions = clone(this.options.role)
            if (this.datum.role === 'admin') {
            } else if (this.datum.role === 'master' || this.datum.role === 'manager' || this.datum.role === 'recruiter' || this.datum.role === 'staff') {
              this.options.role = []
              for (let orgRole of orgRoleOptions) {
                if (orgRole.value === 'master' || orgRole.value === 'manager' || orgRole.value === 'recruiter' || orgRole.value === 'staff') {
                  this.options.role.push(orgRole)
                }
              }
            } else if (this.datum.role === 'agent' || this.datum.role === 'consultant') {
              this.options.role = []
              for (let orgRole of orgRoleOptions) {
                if (orgRole.value === this.datum.role) {
                  this.options.role.push(orgRole)
                }
              }
            }

            this.validateInput()

            this.recentDatum = clone(this.datum)

            this.changed = false
            this.valid = false
          } else {
            message = 'Not Found Data'
          }
        }).catch((err) => {
          console.log(err)

          message = 'データの読込に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
        this.handleLink(`/${this.$route.params.directory}/users`)
      }

      this.$forceUpdate()

      this.$nextTick(() => {
        this.$refs.observer.reset()
      })
    },
    onClose () {
      if (this.mode === 'show') {
        this.doClose()
      } else if (this.mode === 'edit') {
        if (!this.changed) {
          this.doClose()
        } else {
          this.msgBoxConfirm('内容が変更されています。変更を破棄しますか？', () => {
            this.doClose()
          })
        }
      } else if (this.mode === 'add') {
        if (!this.changed) {
          this.doClose()
        } else {
          this.msgBoxConfirm('内容が変更されています。変更を破棄しますか？', () => {
            this.doClose()
          })
        }
      }
    },
    doClose () {
      this.handleLink(`/${this.$route.params.directory}/users`)
    },
    async onSave () {
      this.valid = await this.$refs.observer.validate()
      if (!this.valid) {
        this.msgBoxError('Invalid Inputs')
      } else {
        this.msgBoxConfirm('メンバー情報を保存しますか？', this.doSave)
      }
    },
    async doSave () {
      this.mask = true

      let datum = clone(this.datum)

      delete datum.postedAt
      delete datum.PostedBy
      delete datum.patchedAt
      delete datum.PatchedBy

      if (datum.role === 'admin' || datum.role === 'master' || datum.role === 'manager' || datum.role === 'recruiter' || datum.role === 'staff') {
        delete datum.company
      }

      if (this.currentUser.role !== 'admin' && this.currentUser.role !== 'master') {
        delete datum.role
      }

      let message = null

      if (this.mode === 'add') {
        await postData(`/users/`, datum).then(async (json) => {
          // this.datum._id = json._id
          this.handleLink(`/${this.$route.params.directory}/users`)
        }).catch((err) => {
          console.log(err)

          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } else {
        await patchData(`/users/${datum._id}`, datum).then(async (json) => {
          this.handleLink(`/${this.$route.params.directory}/users`)
        }).catch((err) => {
          console.log(err)

          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      }
    },
    onDelete () {
      if (!this.currentUser.acl || !this.currentUser.acl.users || !this.currentUser.acl.users.delete) {
        return
      }

      this.msgBoxConfirm('メンバー情報を削除しますか？', this.doDelete)
    },
    async doDelete () {
      this.mask = true

      let message = ''

      await deleteData(`/users/${this.datum._id}`).then((json) => {
        this.handleLink(`/${this.$route.params.directory}/users`)
      }).catch((err) => {
        console.log(err)

        message = 'データの削除に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }
      })

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.body
  .form
    overflow-y scroll
    overflow-x hidden
    height calc(100vh - 3.75rem - 5.5rem - 4.75rem)
</style>
